// extracted by mini-css-extract-plugin
module.exports = {"scrollIndicator":"scroll-indicator_scrollIndicator__RM6Oa","scrollBarContainer":"scroll-indicator_scrollBarContainer__3aqBf","scrollBar":"scroll-indicator_scrollBar__1IHqG"};